// Note: The first file of a module here, must also register the module

import "./access-type.component";
import "./building.component";
import "./building-houses.component";
import "./edit-floor.component";
